module.exports = __webpack_public_path__ + "static/img/陈文辉.7a60736.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/teacher/陈文辉.jpg
// module id = NweF
// module chunks = 138